import { PayCode } from 'components/PayCodeSelectInput/PayCodeSelectInput.types';
import { payCodeToOption } from 'components/PayCodeSelectInput/payCodeToOption';
import { useEffect, useMemo, useRef, useState } from 'react';
import { API_GET_schedulingMeta } from 'requests/GET_schedulingMeta';
import { useAPIActions } from 'store/reducers/api/apiSlice';

export function usePayCodes(isEnabled = true) {
  const { apiRequest } = useAPIActions();
  const [payCodes, setPayCodes] = useState<PayCode[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const isMountedRef = useRef(true);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!isEnabled || hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    setIsLoading(true);
    setIsError(false);
    apiRequest(API_GET_schedulingMeta(), {
      onSuccess: (response) => {
        if (!isMountedRef.current) return;
        const fetchedPayCodes: PayCode[] = response?.data?.pay_codes ?? [];
        setPayCodes(fetchedPayCodes);
        setIsLoading(false);
      },
      onError: () => {
        if (!isMountedRef.current) return;
        hasFetchedRef.current = false;
        setIsError(true);
        setIsLoading(false);
      },
    });
  }, [isEnabled]); // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(
    () => ({
      payCodes,
      options: payCodes.map(payCodeToOption),
      isLoading: isEnabled && isLoading,
      isError,
    }),
    [payCodes, isEnabled, isLoading, isError],
  );
}
